<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <main-layout classes="detail-view" ref="detailView">
    <div>
      <vue-headful
        :title="getTitle !== undefined ? getTitle : '고시원 찾을 땐? 고시락'"
        :description="getDescription || ''"
        :keywords="getKeyword || ''"
        :image="getTitleImage || ''"
        :url="'https://kosirock.com/detail/' + getPk"
        :head="{
          'meta[title]': getTitle,
        }"
      />
      <main-menu-header class="not-show-sm"></main-menu-header>
      <header v-sticky="{zIndex: 100}" >
        <div class="detail-header-wrapper">
          <div class="detail-header-container flex">
            <div class="left-view flex flex-center">
              <span class="mobile-back-btn" @click="moveToBack"></span>
              <h1 class="show-sm-only">
                <img src="../assets/images/detail-logo@3x.png" :style="{width:'11.5rem', height:'4.375rem'}" @click="moveToHome"/>
              </h1>
              <h1 class="not-show-sm">
                {{kosiwon.name}} {{kosiwon.branch}}
              </h1>
              <span class="money">{{kosiwon.price_min}} ~ {{kosiwon.price_max}}<span class="unit"> 만원</span>
              </span>
              <span class="money" v-if="kosiwon.deposit"><span class="unit">보증금 : </span>{{kosiwon.deposit}}<span class="unit"> 만원</span></span>
            </div>
            <div class="right-view flex flex-center">
              <div class="sms-item" @click="sendToKakaoTalk" v-if="kosiwon.cellphone_no">
                <span class="sub-info">문자문의</span>
              </div>
              <div class="call-item">
                <span class="sub-info">전화문의 </span>
                <span class="phone-number">{{hypenPhoneNo}}</span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="detail-image-container">
        <div class="detail-image-wrapper">
          <div class="btn-wrapper flex not-show-sm">
            <button class="homepage-btn" @click="moveToHomePage">홈페이지</button>
            <button class="pick-btn" @click="togglePickItem" :class="{on: isPickItem()}">찜하기</button>
            <button class="share-btn" @click="copyTestingCode">URL 복사</button>
            <button class="edit-info-btn" @click="openEditKosiwonModal">정보 수정요청</button>
            <!-- <button class="report-btn" @click="openReportModal">신고</button> -->
            <!-- <button class="share-kakao" @click="shareKakao">카카오톡 공유</button> -->
          </div>
          <div class="options-simple-view flex not-show-sm">
            <!--<span class="collage">서일대</span>-->
            <subway-info :traffic="getSubwayTraffic"></subway-info>
            <hash-tag-list :options="getHashTagOption" v-if="kosiwon.pk"></hash-tag-list>
          </div>
          <image-slider-view :image-list="imageList" />
          <h1 class="show-sm-only mobile-header">{{kosiwon.name}} {{kosiwon.branch}}</h1>
          <div class="money-view show-sm-only flex">
            <span class="money">{{kosiwon.price_min}} ~ {{kosiwon.price_max}}<span class="unit"> 만원</span></span>
            <span class="money" v-if="kosiwon.deposit"><span class="unit">보증금 : </span>{{kosiwon.deposit || 0}}<span class="unit"> 만원</span></span>
          </div>
          <div class="options-simple-view flex show-sm-only">
            <!--<span class="collage">서일대</span>-->
            <subway-info :traffic="getSubwayTraffic"></subway-info>
          </div>
          <div class="hash-tag-list-view flex show-sm-only">
            <hash-tag-list :options="getHashTagOption" v-if="kosiwon.pk"></hash-tag-list>
          </div>
          <div class="btn-wrapper show-sm-only">
            <div class="flex">
              <button class="homepage-btn" @click="moveToHomePage">홈페이지</button>
              <button class="pick-btn" @click="togglePickItem" :class="{on: isPickItem()}">찜하기</button>
            </div>
            <div class="flex">
              <button class="share-btn" @click="copyTestingCode">URL 복사</button>
              <!-- <button class="share-kakao" @click="shareKakao">카카오톡 공유</button> -->
              <!-- <button class="report-btn" @click="openReportModal">신고</button> -->
              <button class="edit-info-btn" @click="openEditKosiwonModal">정보 수정요청</button>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-info-container">
        <!--<nav class="tabs">-->
          <!--<a href="#institution" class="scrollactive-item"><span>시설정보</span></a>-->
          <!--<a href="#private-option" class="scrollactive-item"><span>내부옵션</span></a>-->
          <!--<a href="#public-option" class="scrollactive-item"><span>공용옵션</span></a>-->
          <!--<a href="#room-info" class="scrollactive-item"><span>빈방정보</span></a>-->
          <!--<a href="#place-info" class="scrollactive-item"><span>위치정보</span></a>-->
          <!--<a href="#review" class="scrollactive-item"><span>추천리뷰</span></a>-->
        <!--</nav>-->
        <div class="detail-info" id="institution">
          <div class="detail-info-title">
            <h3>시설정보</h3>
          </div>
          <div class="detail-info-contents">
            <table class="vertical-table not-show-sm">
              <colgroup>
                <col width="13%">
                <col width="19%">
                <col width="13%">
                <col width="19%">
                <col width="13%">
                <col width="19%">
              </colgroup>
              <tbody>
              <tr>
                <th>해당층/건물층</th>
                <td>{{kosiwon.floor}}층 / {{kosiwon.building_floor || '-'}}층</td>
                <th>주차장</th>
                <td>{{kosiwon.options.is_parking ? '있음' : '없음'}}</td>
                <th>냉방여부</th>
                <td>{{kosiwon.options.option_aircon ? '개별냉방' : '중앙냉방'}}</td>
              </tr>
              <tr>
                <th>엘리베이터</th>
                <td>{{kosiwon.options.is_elevator ? '있음' : '없음'}}</td>
                <th>2인실</th>
                <td>{{kosiwon.options.is_double_room ? '있음' : '없음'}}</td>
                <th>난방</th>
                <td>{{getHeatingType}}</td>
              </tr>
              </tbody>
            </table>
            <table class="vertical-table show-sm-only">
              <colgroup>
                <col width="35%">
                <col width="auto">
              </colgroup>
              <tbody>
              <tr>
                <th>해당층/건물층</th>
                <td>{{kosiwon.floor}}층 / {{kosiwon.building_floor || '-'}}층</td>
              </tr>
              <tr>
                <th>주차장</th>
                <td>{{kosiwon.options.is_parking ? '있음' : '없음'}}</td>
              </tr>
              <tr>
                <th>냉방여부</th>
                <td>{{kosiwon.options.option_aircon ? '개별냉방' : '중앙냉방'}}</td>
              </tr>
              <tr>
                <th>엘리베이터</th>
                <td>{{kosiwon.options.is_elevator ? '있음' : '없음'}}</td>
              </tr>
              <tr>
                <th>2인실</th>
                <td>{{kosiwon.options.is_double_room ? '있음' : '없음'}}</td>
              </tr>
              <tr>
                <th>난방</th>
                <td>{{getHeatingType}}</td>
              </tr>
              </tbody>
            </table>
            <div class="detail-info-fragments flex align-center justify-space-between type-container">
              <div class="type-wrapper room">
                <h5 class="sub-title">룸타입</h5>
                <div class="type-container">
                  <div class="type" :class="{on: isSameRoomType('M')}">
                    <img :src="getRoomTypeImage('M')"/>
                    <span>미니룸</span>
                  </div>
                  <div class="type" :class="{on: isSameRoomType('S')}">
                    <img :src="getRoomTypeImage('S')"/>
                    <span>샤워룸</span>
                  </div>
                  <div class="type" :class="{on: isSameRoomType('O')}">
                    <img :src="getRoomTypeImage('O')"/>
                    <span>원룸</span>
                  </div>
                </div>
              </div>
              <div class="type-wrapper gender">
                <h5 class="sub-title">성별</h5>
                <div class="type-container">
                  <div class="type" :class="{on: isSameGenderType('U')}">
                    <img :src="getGenderImage('U')"/>
                    <span>남녀공용</span>
                  </div>
                  <div class="type" :class="{on: isSameGenderType('S')}">
                    <img :src="getGenderImage('S')" />
                    <span>남녀층분리</span>
                  </div>
                  <div class="type" :class="{on: isSameGenderType('W')}">
                    <img :src="getGenderImage('W')" />
                    <span>여성전용</span>
                  </div>
                  <div class="type" :class="{on: isSameGenderType('M')}">
                    <img :src="getGenderImage('M')" />
                    <span>남성전용</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-info-fragments">
              <h5 class="sub-title">시설 소개</h5>
              <!-- <p class="kosiwon-intro">{{kosiwon.description}}</p> -->
              <p class="kosiwon-intro" v-html="kosiwon.description"></p>
            </div>
          </div>
        </div>
        <div class="detail-info" id="private-option">
          <div class="detail-info-title">
            <h3>내부옵션</h3>
          </div>
          <div class="detail-info-contents">
            <div class="detail-info-fragments option-list pb-0">
              <div class="option" v-if="kosiwon.options.option_bed">
                <img src="../assets/images/ex-bed.png"/>
                <span>침대</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_desk">
                <img src="../assets/images/ex-desk.png"/>
                <span>책상</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_closet">
                <img src="../assets/images/ex-closet.png"/>
                <span>옷장</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_refrigerator">
                <img src="../assets/images/ex-ref.png"/>
                <span>냉장고</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_aircon">
                <img src="../assets/images/ex-air.png"/>
                <span>에어컨</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_wash">
                <img src="../assets/images/ex-wash.png"/>
                <span>세탁기</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_doorlock">
                <img src="../assets/images/ex-door.png"/>
                <span>도어락</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_tv">
                <img src="../assets/images/ex-tv.png"/>
                <span>TV</span>
              </div>
              <div class="option" v-if="kosiwon.options.option_internet">
                <img src="../assets/images/ex-wifi.png"/>
                <span>인터넷</span>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-info" id="public-option">
          <div class="detail-info-title">
            <h3>공용옵션</h3>
          </div>
          <div class="detail-info-contents">
            <div class="detail-info-fragments option-list pb-0">
              <div class="option" v-if="kosiwon.options.is_kitchen">
                <img src="../assets/images/ex-kitchen.png"/>
                <span>주방</span>
              </div>
              <div class="option" v-if="kosiwon.options.is_meal">
                <img src="../assets/images/ex-cook.png"/>
                <span>식사제공</span>
              </div>
              <div class="option" v-if="kosiwon.options.is_washroom">
                <img src="../assets/images/ex-wash.png"/>
                <span>세탁실</span>
              </div>
              <div class="option" v-if="kosiwon.options.is_dry">
                <img src="../assets/images/ex-dry.png"/>
                <span>건조기</span>
              </div>
              <div class="option" v-if="kosiwon.options.is_cctv">
                <img src="../assets/images/ex-cctv.png"/>
                <span>CCTV</span>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="detail-info" id="room-info">-->
          <!--<div class="detail-info-title flex justify-space-between">-->
            <!--<h3>빈방정보</h3>-->
            <!--<span class="comment">고시락은 통신판매중개자이며 통신판매의 당사자가 아닙니다. 따라서 고시락은 고시원 정보 및 거래에 대해 책임지지 않습니다.</span>-->
          <!--</div>-->
          <!--<div class="detail-info-contents">-->
            <!--<div class="detail-info-fragments pb-0">-->
              <!--<table class="room-info-table">-->
                <!--<thead>-->
                <!--<tr>-->
                  <!--<th>룸</th>-->
                  <!--<th>타입</th>-->
                  <!--<th>창문</th>-->
                  <!--<th>성별</th>-->
                  <!--<th>인원</th>-->
                  <!--<th>크기</th>-->
                  <!--<th>입실료</th>-->
                  <!--<th>공실여부</th>-->
                <!--</tr>-->
                <!--</thead>-->
                <!--<tbody v-if="kosiwon.rooms.length > 0">-->
                <!--<tr v-for="(room, index) in kosiwon.rooms" :key="`__ROOMS__${index}`">-->
                  <!--<td>{{room.room_number}}호</td>-->
                  <!--<td>{{getRoomType(room.room_type)}}</td>-->
                  <!--<td>{{room.option_in_window ? '내창' : '외창'}}</td>-->
                  <!--<td>{{getUseSexType(room.use_sex_type)}}</td>-->
                  <!--<td>{{room.recommand_number_people}}인실</td>-->
                  <!--<td>{{room.room_size}}m<sup>2</sup></td>-->
                  <!--<td>{{room.price}}만원</td>-->
                  <!--<td>공실없음</td>-->
                <!--</tr>-->

                <!--</tbody>-->
                <!--<tbody v-else>-->
                <!--<tr>-->
                  <!--<td colspan="8">공실 정보가 없습니다.</td>-->
                <!--</tr>-->
                <!--</tbody>-->
              <!--</table>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <div class="detail-info" id="place-info">
          <div class="detail-info-title">
            <h3>위치 정보</h3>
          </div>
          <div class="detail-info-contents">
            <div class="detail-info-fragments bb-0 pb-0 map-view">
              <p>{{kosiwon.address_brief}} {{kosiwon.address_detail}}</p>
              <div class="map" style="width:100%; height:400px;">
                <place-search-map v-if="kosiwon.location.coordinates.length > 0" :category="selectedCategory"
                                  :center="{lat: kosiwon.location.coordinates[0], lng: kosiwon.location.coordinates[1]}"/>
              </div>
              <ul id="category">
                <li id="FD6"><a class="restaurant" href="javascript:void(0);" :class="{on: selectedCategory === 'FD6'}" @click="selectedCategory = 'FD6'">음식점</a></li>
                <li id="CE7"><a class="cafe" href="javascript:void(0);" :class="{on: selectedCategory === 'CE7'}" @click="selectedCategory = 'CE7'">카페</a></li>
                <li id="CS2"><a class="shop" href="javascript:void(0);" :class="{on: selectedCategory === 'CS2'}" @click="selectedCategory = 'CS2'">편의점</a></li>
                <li id="SW8"><a class="transport" href="javascript:void(0);" :class="{on: selectedCategory === 'SW8'}" @click="selectedCategory = 'SW8'">대중교통</a></li>
                <li id="BK9"><a class="bank" href="javascript:void(0);" :class="{on: selectedCategory === 'BK9'}" @click="selectedCategory = 'BK9'">은행</a></li>
              </ul>
            </div>
          </div>
        </div>
        <!--<div class="detail-info" id="review">-->
          <!--<div class="detail-info-title flex justify-space-between bb-0">-->
            <!--<h3>추천 리뷰</h3>-->
          <!--</div>-->
          <!--<div class="detail-info-contents">-->
            <!--<div class="detail-info-fragments bb-0 pb-0 review-view">-->
              <!--<div class="review" style="width:100%; height:200px;"></div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="detail-suggestion-kosiwon-container">
        <div class="suggestion-view">
          <package-list
            :view-type="'row'"
            :title="'추천 고시원'"
            :item-count="!getIsSmall ? 4 : 2"
            :slide-to-show="!getIsSmall ? 1 : 1"
            :navButtons="!getIsSmall"
            :latlng="{lat:1, lng:1}"></package-list>
        </div>
      </div>
      <div class="show-sm-only btn-footer">
        <button class="homepage-btn" @click="sendToKakaoTalk" v-if="kosiwon.cellphone_no">문자문의</button>
        <button class="call-btn" :class="{'full-button': !kosiwon.cellphone_no}" @click="callToKosiwon">전화문의</button>
      </div>
      <default-footer :color="'grey'" class="not-show-sm" />
    </div>
    <edit-kosiwon-modal :kosiwon-id="$route.params.pk" />
    <send-to-kakao-talk-modal :kosiwon-id="$route.params.pk" />
  </main-layout>
</template>

<script>
  import MainLayout from '../components/Layout/MainLayout'
  import MainMenuHeader from '../components/Header/MainMenuHeader'
  import ImageSliderView from '../components/Detail/ImageSliderView'
  import sampleImages from '../assets/images/5c666f13c3db1f3a79926b28_304639_1552534778170.jpeg'
  import PackageList from '../components/Suggestion/PackageList'
  import DefaultFooter from '../components/Footer/index'
  import kosiwonApi from '../api/kosiwons'
  import Utils from '../utils/Utils'
  import KosiwonConstant from '../const/kosiwons'
  import VueSticky from 'vue-sticky'
  import SubwayInfo from '../components/Kosiwons/SubwayInfo'
  import _ from 'underscore'
  import PlaceSearchMap from '../components/Maps/PlaceSearchMap'
  import {mapState} from 'vuex'
  import Config from '../config/index'
  import Notifications from '../utils/Notifications'

  //image
  import genderImage from '../assets/images/ex-gender.png'
  import genderOnImage from '../assets/images/ex-gender-on.png'
  import floorImage from '../assets/images/ex-floor.png'
  import floorOnImage from '../assets/images/ex-floor-on.png'
  import femaleImage from '../assets/images/ex-female.png'
  import femaleOnImage from '../assets/images/ex-female-on.png'
  import maleImage from '../assets/images/ex-male.png'
  import maleOnImage from '../assets/images/ex-male-on.png'

  import miniRoomImage from '../assets/images/ex-mini.png'
  import miniRoomOnImage from '../assets/images/ex-mini-on.png'
  import showerRoomImage from '../assets/images/ex-shower.png'
  import showerRoomOnImage from '../assets/images/ex-shower-on.png'
  import oneRoomImage from '../assets/images/ex-one.png'
  import oneRoomOnImage from '../assets/images/ex-one-on.png'
  import HashTagList from '../components/Kosiwons/hashTagList'
  import EditKosiwonModal from '../components/Modal/EditKosiwonModal'
  import VueHeadful from 'vue-headful'

  import noImages from  '../assets/images/non_thumb.jpg'
  import DynamicNavigator from '../core/modules/DynamicNavigator'
  import SendToKakaoTalkModal from '../components/Modal/SendToKakaoTalkModal'

  const huesikLogo = 'https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/detail-logo.png'

  export default {
    name: 'Detail',
    components: {
      SendToKakaoTalkModal,
      VueHeadful,
      EditKosiwonModal,
      HashTagList,
      PlaceSearchMap,
      SubwayInfo,
      DefaultFooter,
      PackageList,
      ImageSliderView,
      MainLayout,
      MainMenuHeader
    },
    directives: {
      'sticky': VueSticky
    },
    data() {
      return {
        sampleImages: sampleImages,
        kosiwon: {
          options: {},
          rooms: [],
          traffics_subway: [],
          traffics_bus: [],
          location: {
            coordinates: [undefined, undefined]
          },
          room_type: ''
        },
        subwayTraffic: [],
        selectedCategory: 'CS2',
        imageList: []
      }
    },
    watch: {
      '$route'(to, from) {
        if (from.params.pk !== to.params.pk) {
          this.load()
          // this.$refs.detailView.$el.scrollTop = 0
          window.scrollTo(0, 0)
        }
      }
    },
    computed: {
      hypenPhoneNo() {
        if (!this.kosiwon) {
          return ''
        }

        return Utils.autoHypenPhone(this.kosiwon.virtual_no)
      },
      getHeatingType() {
        if (!this.kosiwon) {
          return ''
        }

        return KosiwonConstant.HEATING_TYPE[this.kosiwon.heating_type]
      },
      getSubwayTraffic() {
        return this.subwayTraffic
      },
      ...mapState({
        pickItem: state => state.INTEREST.PICK_LIST
      }),
      getHashTagOption () {
        return {
          use_sex_type: this.kosiwon.options.use_sex_type,
          room_type: this.kosiwon.room_type,
          option_aircon: this.kosiwon.options.option_aircon,
          is_elevator: this.kosiwon.options.is_elevator,
          is_parking: this.kosiwon.options.is_parking,
          option_doorlock: this.kosiwon.options.option_doorlock,
        }
      },
      getIsSmall () {
        return Utils.isSmallScreen()
      },
      getTitle () {
        // :title="kosiwon.name + kosiwon.branch + ' | 고시원 찾을 땐? 고시락'"
        // :description="kosiwon.name + ' | ' + kosiwon.address_brief"
        // :keywords="kosiwon.intro"
        // :image="imageList.length > 0 ? imageList[0] : ''"
        return this.kosiwon && this.kosiwon.name ? `${this.kosiwon.name} ${this.kosiwon.branch} | 고시원 찾을 땐? 고시락` : '고시원 찾을 땐? 고시락'
      },
      getDescription () {
        return this.kosiwon && this.kosiwon.intro ? `${this.kosiwon.intro}` : '고시락 홈페이지 상세 페이지'
      },
      getKeyword () {
        return this.kosiwon && this.kosiwon.name ? `${this.kosiwon.name},${this.kosiwon.address_brief} 고시원,` : ''
      },
      getTitleImage () {
        return this.imageList.length > 0 ? this.imageList[0] : noImages
      },
      getPk () {
        return this.$route.params.pk
      }
    },
    methods: {
      getRoomType(roomType) {
        return KosiwonConstant.ROOM_TYPE[roomType]
      },
      getUseSexType(useSexType) {
        return KosiwonConstant.USE_SEX_TYPE[useSexType]
      },
      setSubwayTraffic() {
        if (this.kosiwon.traffics_subway.length === 0) {
          return
        }
        this.subwayTraffic = this.kosiwon.traffics_subway
      },
      getGenderImage(type) {

        let imageUrl

        switch (type) {
        case 'U':
          if (this.isSameGenderType(type)) {
            imageUrl = genderOnImage
          } else {
            imageUrl = genderImage
          }
          break
        case 'W':
          if (this.isSameGenderType(type)) {
            imageUrl = femaleOnImage
          } else {
            imageUrl = femaleImage
          }
          break
        case 'M':
          if (this.isSameGenderType(type)) {
            imageUrl = maleOnImage
          } else {
            imageUrl = maleImage
          }
          break
        case 'S':
          if (this.isSameGenderType(type)) {
            imageUrl = floorOnImage
          } else {
            imageUrl = floorImage
          }
          break
        }

        return imageUrl
      },
      isSameGenderType (type) {
        return type === this.kosiwon.options.use_sex_type
      },

      getRoomTypeImage(type) {

        let imageUrl

        switch (type) {
        case 'M':
          if (this.isSameRoomType(type)) {
            imageUrl = miniRoomOnImage
          } else {
            imageUrl = miniRoomImage
          }
          break
        case 'S':
          if (this.isSameRoomType(type)) {
            imageUrl = showerRoomOnImage
          } else {
            imageUrl = showerRoomImage
          }
          break
        case 'O':
          if (this.isSameRoomType(type)) {
            imageUrl = oneRoomOnImage
          } else {
            imageUrl = oneRoomImage
          }
          break
        }

        return imageUrl
      },
      isSameRoomType (type) {
        return this.kosiwon.room_type && this.kosiwon.room_type.indexOf(type) > -1
      },

      async load() {
        const id = this.$route.params.pk

        try {
          const kosiwon = await kosiwonApi.detail({
            id
          })
         
          // 삭제된 고시원이거나, 승인되지 않은 고시원일 경우 Catch로 보내서 메인 페이지로 이동
          // 삭제 : is_deleted = 1, 미승인 : is_public = 0
          if (kosiwon.data.result.is_deleted || !kosiwon.data.result.is_public) {
            throw new Error("NOT_EXIST_KOSIWON")
          } else {
            this.kosiwon = kosiwon.data.result

            this.setSeoMetaTag()

            this.$store.dispatch('setLastViewList', this.kosiwon)
            this.setSubwayTraffic()
            this.flattenImage()
            this.selectedCategory = 'CS2'
          }
        } catch(err) {
          this.$router.push({path : "/"});
        }
      },
      setSeoMetaTag() {
        // document.querySelector('meta[name=description]').setAttribute('content', this.kosiwon.description)
        // document.title = this.kosiwon.name
        // document.querySelector('meta[property="og:image"]').setAttribute('content', this.kosiwon.thumbnail_url)
        // document.querySelector('link[rel="canonical"]').setAttribute('href', `https://kosirock.com/detail/${this.kosiwon.pk}`)
        // document.querySelector('meta[property="og:url"]').setAttribute('content', `https://kosirock.com/detail/${this.kosiwon.pk}`)
        // document.querySelector('meta[description]').innerHTML = this.kosiwon.description
        // document.querySelector('meta[description]').innerHTML = this.kosiwon.description
      },
      flattenImage () {
        const imageCategoryList = this.kosiwon.categories
        let imageList = []

        imageCategoryList.map(category => {
          category.groups.map(group => {
            const _imageList = _.pluck(group.images, 'image_url')
            imageList = imageList.concat(_imageList)
          })
        })

        this.imageList = imageList
      },
      togglePickItem() {
        if (this.isPickItem()) {
          this.$store.dispatch('removePickList', this.kosiwon)
        } else {
          this.$store.dispatch('setPickList', this.kosiwon)
        }
      },
      isPickItem() {
        return _.find(this.pickItem, (item) => {
          return item.pk === this.kosiwon.pk
        })
      },
      shareKakao() {

        const name = `${this.kosiwon.name} ${this.kosiwon.branch}`;

        const kakaoObject = {
          content: {
            title: name,
            description: this.kosiwon.description,
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href,
            },
          },
          buttons: [
            {
              title: '웹으로 보기',
              link: {
                mobileWebUrl: window.location.href,
                webUrl: window.location.href,
              },
            },
          ],
        }
        
        this.kosiwon.thumbnail_url ? kakaoObject.content.imageUrl = this.kosiwon.thumbnail_url : kakaoObject.content.imageUrl = huesikLogo;

        console.log(kakaoObject.content)

        if(this.kosiwon.address_brief) {
          kakaoObject.objectType = 'location';
          kakaoObject.address = this.kosiwon.address_brief;
          kakaoObject.addressTitle = name;
        } else {
          kakaoObject.objectType = 'feed';
        }
        
        Kakao.Link.sendDefault(kakaoObject)
      }, 
      copyTestingCode () {
        const copyElem = document.createElement('input')
        copyElem.setAttribute('type', 'text')    // 不是 hidden 才能複製
        document.body.appendChild(copyElem)
        copyElem.value = window.location.href
        copyElem.select()
        try {
          let successful =  document.execCommand('copy')
          if (this.$store.state.APP.IS_NATIVE) {
            window.cordova.plugins.clipboard.copy(window.location.href)
            successful = true
          }

          if (successful) {
            Notifications.alert('현재 고시원의 주소가 복사되었습니다.')
          }
        } catch (err) {
          console.log(err)
        }
        /* unselect the range */
        copyElem.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
        copyElem.remove()
      },
      moveToHomePage() {
        if (this.kosiwon.url) {
          if(window.gtag) {
            window.gtag('event', '버튼 클릭', {
              event_category: '홈페이지',
              event_label: `${this.kosiwon.name} ${this.kosiwon.branch}`
            });
          }
          DynamicNavigator.getInstance().moveToHomePage(this.kosiwon.url+'/?utm_source=kosirock&utm_medium=home&utm_campaign='+ this.kosiwon.url.split('.')[0].split('//')[1] )
        } else {
          Notifications.alert('홈페이지가 존재하지 않습니다.');
        }
      },
      openEditKosiwonModal () {
        this.$modal.show('edit-kosiwon-modal')
      },
      openReportModal () {
        this.$modal.show('edit-kosiwon-modal')
      },
      moveToBack () {
        DynamicNavigator.getInstance().detailToBack(this.$router)
      },

      async callToKosiwon () {

        // 외주사가 작업한 내용 : 작동되지 않아서 현재 Block
        // 추후 call 수 제한 할 때 사용할 예정.
        // console.log(this.kosiwon.pk)
        // const kosiwonId = this.kosiwon.pk
        // const name = `${this.kosiwon.name}(${this.kosiwon.branch}) `
        // const phone = this.hypenPhoneNo.replace(/[^0-9]/g,'')
        // const limit = await this.axios.post(`https://assistant.kosirock.com/kosiwon/${kosiwonId}/callmix`, {name : name, phoneNum: phone })
        // console.log(limit)

        if(window.gtag) {
          window.gtag('event', '버튼 클릭', {
            event_category: '전화 문의',
            event_label: `${this.kosiwon.name} ${this.kosiwon.branch} : ${this.hypenPhoneNo}`
          });
        }

        window.location = `tel://${this.hypenPhoneNo}`;
      },
      moveToHome () {
        this.$router.push('/')
      },
      sendToKakaoTalk () {
        this.$modal.show('send-to-kakao-talk-modal')
      }
    },
    async mounted() {

      // 초기화
      // Kakao.init('b98ef796b53b8557e2ed3fc019fb1319');
      // Kakao.isInitialized();  // Key 초기화.

      const {query, params} = this.$route
      // 리뉴얼 이전 고시락 페이지 접속 시 Redirect
      if (query.before || params.pk.indexOf('?') > -1) {
        const pk = params.pk.split('?')[0]
        const newIdData = await this.axios.get(`/kosiwons/getNewId/${pk}`)
        const newId = newIdData.data.result
        this.$router.replace(`/detail/${newId}`)
      }
      else {
        this.$store.dispatch('setNetworkIndicator', true)
        this.load()
      }
    },
    beforeDestroy () {
      document.querySelector('meta[name=description]').setAttribute('content', '고시원 찾을 땐? 고시락!')
      document.title = '고시원 찾을 땐? 고시락!'
      document.querySelector('meta[property="og:image"]').setAttribute('content', '')
      document.querySelector('link[rel="canonical"]').setAttribute('href', 'https://kosirock.com')
      document.querySelector('meta[property="og:url"]').setAttribute('content', 'https://kosirock.com')
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/css/palette";

  .detail-view {
    /*overflow: auto;*/
    background-color: @white;

    .detail-header-wrapper {
      background-color: @windows-blue;
      padding: 1.5rem 1rem;

      .detail-header-container {
        justify-content: space-between;
        align-items: center;
        max-width: 120rem;
        margin: auto;
        font-weight: bold;
        font-size: 2.5rem;
        color: @white;

        .left-view {
          h1 {
            display: inline-block;
            font-weight: bold;
            padding: 0.5rem 2rem 0.5rem 0.5rem;
            border-right: 1px solid @very-light-pink-two;
          }

          .money {
            padding: 0.5rem 2rem 0.5rem 2rem;

            &:last-child {
              border-left: 1px solid @very-light-pink-two;
            }
            .unit {
              font-size: 2rem;
            }
          }
        }

        .right-view {
          > div {
            border: 1px solid white;
            border-radius: 2rem;
            font-size: 1.6rem;
            padding: 0.7rem 1.1rem;
            display: flex;
            align-items: center;
            box-sizing: border-box;

            &:before {
              background-size: 2.2rem;
              background-repeat: no-repeat;
              background-position: center left;
              display: inline-block;
              content: '';
              width: 2.2rem;
              height:2.2rem;
            }

            .sub-info {
              font-weight: normal;
            }

            &.call-item {
              &:before {
                background-image: url("../assets/images/ex-call-mobile-footer@3x.png");
              }

              .sub-info {
                padding: 0 1rem;
              }

              .phone-number {
                font-size: 2.4rem;
              }
            }
          }

          .sms-item {
            padding: 0.8rem 1.5rem;
            margin-right: 2rem;
            cursor: pointer;
            &:before {
              padding-right: 1rem;
              background-image: url("../assets/images/message@3x.png");
              background-size: 1.75rem 1.45rem;
            }
          }
        }
      }
    }

    .detail-image-container {
      border-bottom: 1px solid @very-light-pink-two;

      .detail-image-wrapper {
        max-width: 120rem;
        margin: auto;
        padding: 1.5rem 1rem 4rem;

        .btn-wrapper {
          padding-bottom: 1.5rem;
          text-align: left;

          button {
            background-color: @white;
            &:before {
              vertical-align: middle;
              display: inline-block;
              /*max-width: 2.5rem;*/
              /*height: 2.5rem;*/
              text-align: center;
              line-height: 2.5rem;
              margin-right: 0.5rem;
              font-size: 1.2rem;
              /*width: 100%;*/
              padding: 2.5rem 1.5rem 0 ;
              content: ''
            }

            &:not(:last-child) {
              &:after {
                content: '·';
                margin: 0 1.5rem;
                color: @very-light-pink-two;
                font-weight: bold;
                font-size: 2.5rem;
              }
            }

            padding: 0;
            line-height: 2.5rem;
            vertical-align: middle;
          }

          .homepage-btn {
            color: @windows-blue;

            &:before {
              background: url("../assets/images/ex-homepgae.png") no-repeat;
              background-size: 2.5rem;
            }
          }

          .share-btn {
            &:before {
              background: url("../assets/images/ex-share2.png") no-repeat;
              background-size: 2.5rem;
            }
          }

          .report-btn {
            &:before {
              background: url("../assets/images/ex-siren.png") no-repeat;
              background-size: 2.5rem;
            }
          }

          .share-kakao {
            &:before {
              background: url("../assets/images/ex-kakao.png") no-repeat;
              background-size: 2.5rem;
            }
          }

          .pick-btn {
            &:before {
              background: url("../assets/images/ex-heart2.png") no-repeat;
              background-size: 2.5rem;
            }
            &.on{
              &:before {
                background: url("../assets/images/ex-heart-on2.png") no-repeat;
                background-size: 2.5rem;
              }
            }
          }

          .edit-info-btn {
            &:before {
              background: url("../assets/images/ex-fix2.png") no-repeat;
              background-size: 2.5rem;
            }
          }
        }

        .options-simple-view {
          text-align: left;
          align-items: center;
          font-size: 1.2rem;
          padding-bottom: 2.5rem;

          .collage {
            margin-right: 1.5rem;
          }

          .hash-tag-list {
            margin-left: 1.5rem;
          }
        }
      }
    }

    .detail-info-container {
      max-width: 120rem;
      margin: auto;
      padding: 0 1rem 5rem;


      .tabs {
        display: flex;
        width: 100%;
        padding-top: 1.5rem;
        background: @white;

        a {
          text-align: center;
          width: 20rem;
          vertical-align: middle;
          box-sizing: border-box;
          border-bottom: 2px solid #cccccc;

          &.on {
            border-bottom: 2px solid @windows-blue;
            color: @windows-blue;
            font-weight: bold;
          }

          span {
            display: block;
            padding-bottom: 1.5rem;
          }
        }
      }

      .detail-info {
        padding-top: 5.2rem;

        .detail-info-title {
          text-align: left;
          border-bottom: 1px solid @brown-grey;
          padding: 1rem 0;

          h3 {
            font-size: 2rem;
            font-weight: bold;
            color: @windows-blue;
          }

          .comment {
            color: @brown-grey;
          }
        }

        .detail-info-contents {
          .vertical-table {
            width: 100%;
            text-align: left;
            display: table;

            tr {
              border-bottom: 1px solid #eeeeee;

              th {
                font-weight: bold;
                max-width: 13rem;
              }

              th, td {
                padding: 1.7rem 0;
              }
            }
          }

          .detail-info-fragments {
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 2.5rem;

            &:last-child {
              border-bottom: 1px solid @brown-grey;
            }

            .sub-title {
              font-weight: bold;
              text-align: left;
              font-size: 1.6rem;
              padding: 1.7rem 0;
            }

            .type-wrapper {
              &:first-child {
                margin-right: 3.5rem;
              }

              &:last-child {
                margin-left: 3.5rem;
              }

              .type-container {
                text-align: left;
                display: flex;
                justify-content: space-between;

                .type {
                  position: relative;
                  /*max-height: 19rem;*/
                  margin-left: 2.5rem;

                  &:first-child {
                    margin-left: 0
                  }

                  &:last-child {
                    margin-right: 0
                  }

                  img {
                    display: block;
                    /*height: 100%;*/
                  }

                  span {
                    position: absolute;
                    color: @brown-grey;
                    padding-top: 2.3rem;
                    display: block;
                    bottom: 1.4rem;
                    left: 0;
                    right: 0;
                    margin: auto;
                    font-weight: bold;
                    text-align: center;
                  }

                  &.on {
                    span {
                      color: @windows-blue;
                    }
                  }
                }
              }
            }

            .kosiwon-intro {
              line-height: 1.5;
              white-space: pre-wrap;
              word-wrap: break-word;
              text-align: left;
              /*font-family: inherit;*/
            }

            &.option-list {
              text-align: left;

              .option {
                display: inline-block;
                height: 100%;
                margin: 0 1rem 0;
                text-align: center;
                position: relative;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                }

                span {
                  position: absolute;
                  bottom: 1.35rem;
                  left: 0;
                  right: 0;
                  margin: auto;
                  display: block;
                  font-weight: bold;
                }
              }
            }

            .room-info-table {
              width: 100%;

              tr {
                height: 5rem;
                border-left: none;
                border-right: none;

                th, td {
                  vertical-align: middle;
                }
              }

              thead {
                tr {
                  border: 1.5px solid #cccccc;
                  border-left: none;
                  border-right: none;
                }

                th {
                  background-color: #eeeeee;
                  font-weight: bold;
                }
              }

              tbody {
                tr {
                  border: 1.5px solid #eeeeee;
                  border-left: none;
                  border-right: none;
                }
              }
            }

            &.map-view {
              p {
                padding: 1.8rem 0;
              }

              .map {
                border: 1px solid @brown-grey;
                background-color: #eeeeee;
              }

              ul {
                text-align: center;
                padding-top: 2.25rem;

                li {
                  display: inline-block;
                  padding: 0 2.5rem;

                  a {
                    padding-top: 85px;
                    display: inline-block;
                    width: 7.5rem;

                    &.restaurant {
                      background: url('../assets/images/ex-res.png') center top no-repeat;
                    }

                    &.cafe {
                      background: url('../assets/images/ex-cafe.png') center top no-repeat;
                    }

                    &.shop {
                      background: url('../assets/images/ex-exp.png') center top no-repeat;
                    }

                    &.transport {
                      background: url('../assets/images/ex-sub.png') center top no-repeat;
                    }

                    &.bank {
                      background: url('../assets/images/ex-bank.png') center top no-repeat;
                    }

                    &.on {
                      &.restaurant {
                        background-image: url('../assets/images/ex-res-on.png');
                      }

                      &.cafe {
                        background-image: url('../assets/images/ex-cafe-on.png');
                      }

                      &.shop {
                        background-image: url('../assets/images/ex-exp-on.png');
                      }

                      &.transport {
                        background-image: url('../assets/images/ex-sub-on.png');
                      }

                      &.bank {
                        background-image: url('../assets/images/ex-bank-on.png');
                      }
                    }
                  }
                }
              }
            }

            &.review-view {
              .review {
                width: 100%;
                height: 20rem;
                background: #eeeeee;
                border: 1px solid @brown-grey;
              }
            }
          }
        }
      }
    }

    .detail-suggestion-kosiwon-container {
      padding: 0 1rem;
      border-top: 1px solid @very-light-pink-two;
      background: @very-light-pink;

      .suggestion-view {
        max-width: 120rem;
        margin: 0 auto;
        padding-bottom: 3.7rem;
        border-bottom: 2px solid #cccccc;
      }
    }
  }
</style>

<style scoped lang="less">
  @import "../assets/css/palette";
  @media screen and (max-width: 1366px) {
    .detail-view {
      .detail-header-wrapper {
        .detail-header-container {
          max-width: 100rem;
        }
      }

      .detail-image-container {
        .detail-image-wrapper {
          max-width: 100rem;
        }
      }

      .detail-info-container {
        max-width: 100rem;
      }
      .detail-suggestion-kosiwon-container {
        .suggestion-view {
          max-width: 100rem;
        }
      }
    }
  }
</style>

<style lang="less" scoped>
  /* 아이패드 미니 세로 */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio: 1)  {
    .detail-view .detail-info-container .detail-info .detail-info-contents .detail-info-fragments.option-list .option {
      width: inherit !important;
    }

    .detail-view .detail-info-container .detail-info .detail-info-contents .detail-info-fragments .type-wrapper .type-container {
      justify-content: center !important;
      .type {
        max-width: 15rem !important;
      }
    }
  }
</style>

<style lang="less" scoped>
  @media screen and (max-width: 1280px) {
    .detail-view .detail-info-container .detail-info .detail-info-contents .detail-info-fragments .type-wrapper .type-container .type {
      max-width: 11rem;
      min-width: 11rem;
      img {
        width: 100%;
      }
    }
  }
</style>

<style scoped lang="less">
  @import "../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .detail-view {
      background: inherit;
      overflow: inherit;
      .detail-header-wrapper {
        padding: 0.95rem 1rem;
        background-color: white;
        border-bottom: 1px solid #eeeeee;

        .detail-header-container {
          justify-content: center;
          .money {
            display: none;
          }
          .right-view {
            display: none;
          }
          .left-view {
            display: block;
            text-align: center;
            h1 {
              display: block;
              border: 0;
              padding: 0;
              color: @black-two;
              font-size: 2rem;
            }
            .mobile-back-btn {
              background: url('../assets/images/ex-back@3x.png') no-repeat no-repeat center center;
              background-size: 1.2rem 2rem;
              padding: 1rem 2rem 0 0;
              position: absolute;
              top:0;
              bottom:0;
              left: 1.45rem;
            }
          }
        }
      }
      .detail-image-container {
        background-color: white;
        .detail-image-wrapper {
          padding:0;
          /*.btn-wrapper {*/
          /*display: none;*/
          /*}*/
          /*.options-simple-view {*/
          /*display: none;*/
          /*}*/
          .mobile-header {
            padding-top: 2rem;
            font-size: 2rem;
            font-weight: bold;
          }

          .money-view {
            padding: 1.625rem 0;
            font-size: 3rem;
            font-weight: bold;
            justify-content: center;
            .money {
              &:nth-child(1) {
                padding-right: 1.1rem;
              }

              &:nth-child(2) {
                padding-left: 1.1rem;
                border-left: 1px solid #cccccc;
              }

              .unit {
                font-size: 1.625rem;
              }
            }
          }

          .options-simple-view {
            justify-content: center;
            padding-bottom: 1.625rem;
            span.collage {
              font-size: 1.5rem;
              &:before {
                background-size: 2.15rem 1.5rem;
                padding: 1.5rem 2.15rem 0 0;
              }
            }
          }

          .hash-tag-list-view {
            justify-content: center;
            padding-bottom: 1.625rem;
            .hash-tag-list {
              font-size: 1.5rem;
            }
          }
          .btn-wrapper {
            border-top: 1px solid @very-light-pink;
            padding-bottom: 0;
            button {
              flex: 1;
              padding: 1rem 0;
              &:after {
                content: '';
                display: none;
              }
              &:before {
                padding: 2.5rem 3rem 0 0;
              }
              border-right: 1px solid @very-light-pink;
            }

            div {
              &:first-child {
                border-bottom: 1px solid @very-light-pink;
              }
            }

            .pick-btn {
              &.on {
                &:before {
                  background-size: 2rem;
                  background-position: center 0.5rem;
                }
              }

              &:before {
                background-size: 2rem;
                background-position: center 0.5rem;
              }
            }
            .homepage-btn {
              &:before {
                background-size: 2rem;
                background-position: center 0.5rem;
              }
            }
            .edit-info-btn {
              &:before {
                background-size: 2rem;
                background-position: center 0.3rem;
              }
            }
            .share-btn {
              &:before {
                background-size: 2rem;
                background-position: center 0.3rem;
              }
            }
            .report-btn {
              &:before {
                background-size: 2rem;
                background-position: center 0.3rem;
              }
            }
            .share-kakao {
              &:before {
                background-size: 2rem;
                background-position: center 0.3rem;
              }
            }
          }
        }
      }
      .detail-info-container {
        margin: 1rem auto 0;
        padding:0 1rem 1rem;
        background: @white;
        .detail-info {
          padding-top: 1.6rem;
          .detail-info-title {
            width: 100%;
            h3 {
              display: block;
              text-align: center;
            }
          }
          .detail-info-contents {
            .vertical-table {
              border-bottom: 1px solid #eeeeee;
              tbody {
                display: table;
                width: 100%;
                tr {
                  border-bottom: none;
                  td {
                    text-align: right;
                  }
                }
              }
            }
            .detail-info-fragments {
              &.type-container {
                display: block;
              }
              .type-wrapper {
                &:first-child {
                  margin-right: 0;
                }
                &:last-child {
                  margin-left: 0;
                }
                .type-container {
                  .type {
                    max-width: initial;
                    min-width: initial;

                    width: 33%;
                    margin-left: 1.5rem;
                    img {
                      width: 100%;
                    }
                  }
                }
              }
              &.option-list {
                text-align: center;
                .option {
                  width: 25%;
                }
              }
              &.map-view {
                ul {
                  li {
                    width: 20%;
                    padding: 0;
                    a {
                      padding-top:4.8rem;
                      padding-bottom: 1rem;
                      width: 100%;

                      &.restaurant {
                        background-size: 3.8rem;
                      }

                      &.cafe {
                        background-size: 3.8rem;
                      }

                      &.shop {
                        background-size: 3.8rem;
                      }

                      &.transport {
                        background-size: 3.8rem;
                      }

                      &.bank {
                        background-size: 3.8rem;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .detail-suggestion-kosiwon-container {
        border-top: 0;
        .suggestion-view {
          border-bottom: 0;
          padding-bottom: 7.7rem;
        }
      }
      .btn-footer {
        position: fixed;
        bottom: 0;
        transform: translateY(0);
        width: 100%;
        z-index: 2;
        button {
          height: 6.25rem;
          width: 50%;
          background-color: @windows-blue;
          color: @white;
          font-size: 2rem;

          &.full-button {
            width: 100%;
          }

          &:before {
            content: '';
            background-repeat: no-repeat no-repeat;
            background-position: center center;
            padding: 1.25rem 0 1.25rem 2.5rem;
            background-size: 2.5rem;
            margin-left: -1.25rem;
            margin-right: 0.5rem;
          }
          &:first-child {
            &:before {
              background-image: url('../assets/images/message@3x.png');
            }
            border-right: 1px solid #6fabe4;
          }
          &:last-child {
            &:before {
              background-image: url('../assets/images/ex-call-mobile-footer@3x.png');
            }
          }
        }
      }
    }
  }
</style>
